export const AI_Phone_Slug = [
  "lp-nw/bca-fintech-ai-paytm",
  "lp-nw/mca-fintech-ai-paytm",
];
export const second_Phone_Slug = [
  "lp-nw/ug-pg-degree-set",
  "lp-nw/bca-mca",
  "lp-nw/bba-mba",
];
